/**
 * Resolve which body-diagram variant to render for a given athlete.
 *
 * Precedence:
 *   1. athlete.sex if explicitly 'male' | 'female'
 *   2. teamGender if explicitly 'male' | 'female'
 *   3. fall back to 'male' (matches legacy default)
 *
 * This lives in shared/ so every BodyMap consumer applies the same rule.
 */
export type BodyMapGender = 'male' | 'female';

interface AthleteLike {
  sex?: string | null;
}

export function resolveBodyMapGender(
  athlete: AthleteLike | null | undefined,
  teamGender?: string | null,
): BodyMapGender {
  if (athlete?.sex === 'male' || athlete?.sex === 'female') {
    return athlete.sex;
  }
  if (teamGender === 'male' || teamGender === 'female') {
    return teamGender;
  }
  return 'male';
}
